import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useRole } from "@/contexts/RoleContext";
import { metiersRepository } from "@/repositories/metiersRepository";
import type { MetierRow, MetierUpdate } from "@/schemas/metier";

export const metiersKeys = {
  all: ["metiers"] as const,
  list: (role: string) => ["metiers", "list", role] as const,
};

export function useMetiers() {
  const { role } = useRole();
  return useQuery<MetierRow[]>({
    queryKey: metiersKeys.list(role),
    queryFn: () => metiersRepository.list(role),
  });
}

export function useUpdateMetier(id: string) {
  const { role } = useRole();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: MetierUpdate) => metiersRepository.update(role, id, patch),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: metiersKeys.all });
    },
  });
}

export function useCreateMetier() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: metiersRepository.create,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: metiersKeys.all });
    },
  });
}

export function useDeleteMetier() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => metiersRepository.remove(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: metiersKeys.all });
    },
  });
}
